module.exports = __webpack_public_path__ + "img/content.d4c0f451.png";